import Gravity from 'Gravity';

const initHeader = () => {
    const header = document.querySelector('.gg-navigation');
    const sectionETFVehicle = document.querySelector('.gg-etf-vehicle');
    const mainManualETF = document.querySelector('.insight-tag-mutual-etf main');
    const mask = document.querySelector('.gg-mask');

    if (!header) {
        return;
    }

    const DOMReplacementElement = header.parentElement.querySelector('.gg-navigation__dom-replacement');
    const menu = header.querySelector('.gg-navigation__main-menu');
    const body = document.querySelector('body');
    const search = header.querySelector('.gravity-block-search');
    const auxMenu = header.querySelector('.gg-navigation__aux-main-menu');
    const drawerLogo = header.querySelector('.gg-navigation__drawer-logo');
    const announcement = header.querySelector('.gg-announcement');
    const btnCloseAnnouncement = header.querySelector('.gg-button-announce')
    const projectHasStickySubNav = true;
    let lastScrollTop = 0;
    let headerScrollTimeout = null;

        const html = document.querySelector('html');
      
        function checkDevice() {
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            html.classList.add('touch');
          } else {
            html.classList.add('no-touch');
          }
        }
      
        function addClassHtml( isFirefox, isSafari, isChrome) {
          if (isFirefox) {
            html.classList.add('firefox');
          }
          if (isChrome && isSafari) {
            html.classList.add('chrome');
          }
          if (!isChrome && isSafari) {
            html.classList.add('safari');
          }
          if (/Edge/.test(navigator.userAgent)) {
            html.classList.add('edge');
          }
          if (/(macintosh|macintel|macppc|mac68k|macos)/i.test(navigator.userAgent)) {
            html.classList.add('mac-os');
          }
        }
      
        function browserDetection() {
          const isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
          const isSafari = navigator.userAgent.indexOf('Safari') > -1;
          const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
          addClassHtml( isFirefox, isSafari, isChrome);
        }
      
        browserDetection();
        checkDevice();
      


    const moveItemsToDrawer = (itemsBefore, itemsAfter) => {
        itemsBefore.forEach((item) => menu.gravity.registerBeforeWrapper(item));
        itemsAfter.forEach((item) => menu.gravity.registerAfterWrapper(item));
        menu.gravity.moveExternalElements();
        document.body.classList.add('gg-navigation--initialized');
    };

    moveItemsToDrawer([drawerLogo], [auxMenu]);

    const navObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            header.classList.toggle('scroll', !entry.isIntersecting);
        });
    });

    const searchObserver = new MutationObserver((mutations) => {
        mutations.forEach(({ target, attributeName }) => {
            if (attributeName === 'class') {
                header.classList.toggle('active-search', target.classList.contains('gravity-block-search--show'));
            }
        });
    });

    const detectDetailInsight = () => {
      const insightTagMutualETF = document.querySelector('.insight-tag-mutual-etf')
      if (insightTagMutualETF) {
        const sectionETFVehicle = insightTagMutualETF.querySelector('main')
        if (!insightTagMutualETF) {
          sectionETFVehicle.style.opacity = 1;
          return;
        }
        const dataUrl = gravityData.dataUrlRedirect;
  
        if (dataUrl) {
            window.location.href = dataUrl;
        } else {
            window.location.href = '/';
        }
      }
    }

    // Hide the header when user scrolls down, show it when scroll up or stop for at least one second
    if (!projectHasStickySubNav) {
        const hideShowHeader = () => {
            const { scrollTop } = document.documentElement;
            const scrollTime = 1000;
            header.classList.toggle('hidden', scrollTop > lastScrollTop);
            lastScrollTop = scrollTop;

            clearTimeout(headerScrollTimeout);
            headerScrollTimeout = setTimeout(() => {
                header.classList.remove('hidden');
            }, scrollTime);
        };
        const scrollDelay = 10;
        window.addEventListener('scroll', Gravity.debounce(hideShowHeader, scrollDelay));
    }

    searchObserver.observe(search, { attributes: true });
    navObserver.observe(DOMReplacementElement);

    const setCookie = (name, value) => {
      document.cookie = name + "=" + (value || "") + "; path=/";
    };

    const setCookieFUll = (name, value, days) => {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    }
    const checkState = () => {
      const cookieName = 'userState';
      const cookieNameV2 = 'user-eu';
      const euCountries = ['at', 'be', 'bg','gb', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se'];
      let state = getCookie(cookieName);
  
      if (state) {
        if(state !== 'uk' && euCountries.includes(state) === false ) {
          checkAnnouncement();
          if (sectionETFVehicle) {
            sectionETFVehicle.style.opacity = 1;
          }
          if (mainManualETF) {
            mainManualETF.style.opacity = 1;
          }
          if (mask) {
            mask.style.opacity = 1;
          }
          body.classList.remove('gg-state-eu');
          setCookieFUll(cookieNameV2, false, 7);
          window.dispatchEvent(new CustomEvent('done-check-state-v2'));
        } else {
          window.dispatchEvent(new CustomEvent('detectIP-eu'));
          detectDetailInsight()
          body.classList.add('gg-state-eu');
          setCookieFUll(cookieNameV2, true, 7);
        }
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('done-check-state'));
          document.body.classList.add('gg-state-checked');
        }, 300);
      } else {
        try {
          fetch('https://www.cloudflare.com/cdn-cgi/trace')
            .then(response => response.text())
            .then(text => {
              state = text.match(/loc=(.+)/)[1].toLowerCase();
              setCookieFUll(cookieName, state, 7);
              if(state !== 'uk' && euCountries.includes(state) === false) {
                checkAnnouncement();
                if (sectionETFVehicle) {
                  sectionETFVehicle.style.opacity = 1;
                }
                if (mainManualETF) {
                  mainManualETF.style.opacity = 1;
                }
                if (mask) {
                  mask.style.opacity = 1;
                }
                body.classList.remove('gg-state-eu');
                setCookieFUll(cookieNameV2, false, 7);
                window.dispatchEvent(new CustomEvent('done-check-state-v2'));
              } else {
                setCookieFUll(cookieNameV2, true, 7);
                window.dispatchEvent(new CustomEvent('detectIP-eu'));
                detectDetailInsight()
                body.classList.add('gg-state-eu');
              }
              setTimeout(() => {
                window.dispatchEvent(new CustomEvent('done-check-state'));
                document.body.classList.add('gg-state-checked');
              }, 300);
              return true;
            })
            .catch(error => {
              console.error('Error fetching state:', error);
              return false;
            })
           
        } catch (error) {
            console.error('Error fetching state:', error);
            return false;
        }
      }
  }


    const getCookie = (name) => {
        const nameEQ = `${name}=`;
        const cookiesArray = document.cookie.split(';');
        for (let cookie of cookiesArray) {
            cookie = cookie.trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length);
            }
        }
        return null;
    };

    const checkAnnouncement = () => {
        const announcementKey = "announcementDismissedV2";
        if (!getCookie(announcementKey) && announcement) {
            announcement.style.display = 'flex';
            body.classList.add('announcement-show');
        }
    };

    checkState();

    btnCloseAnnouncement.addEventListener('click', () => {
        const announcementKey = "announcementDismissedV2";
        setCookie(announcementKey, "true", 1); 
        announcement.style.display = 'none';
        body.classList.remove('announcement-show');
    });

};
export default initHeader;
